import React from 'react';
import './MobileApp.css';
import MobileHeader from './MobileHeader';
import MobileMainContent from './MobileMainContent'; // Наш новый, умный компонент
import { LanguageProvider } from './LanguageContext';

import AIChatBot from './AIChatBot';
import WhatsAppWidget from './WhatsAppWidget';
import FloatingActionsContainer from './components/FloatingActionsContainer';

// Он, сука, стал тупым. И это заебись.
const MobileApp = () => {
    // Убираем нахуй всю старую логику отсюда.
    // Ей здесь не место.

    return (
        <LanguageProvider>
            <div className="mobile-page-wrapper">
                <MobileHeader />
                <MobileMainContent /> {/* Просто вызываем главный компонент */}
                
                {/* Все плавающие элементы остаются здесь */}
                <FloatingActionsContainer>
                    <AIChatBot />
                    <WhatsAppWidget />
                </FloatingActionsContainer>
                
            </div>
        </LanguageProvider>
    );
};

export default MobileApp;